export default __webpack_public_path__ + "static/media/main-swiper-2.ae55017b.png";